<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M9 3C9 2.44772 9.44772 2 10 2C10.5523 2 11 2.44772 11 3V4.10002C13.2822 4.56329 15 6.58104 15 9V9.82435C15 10.5909 15.2269 11.3404 15.6521 11.9782L16.8711 13.8066C16.9551 13.9327 17 14.0809 17 14.2324C17 14.6563 16.6563 15 16.2324 15H11.7324H8.26756H3.76759C3.34366 15 3 14.6563 3 14.2324C3 14.0809 3.04486 13.9327 3.12892 13.8066L4.34787 11.9782C4.77309 11.3404 5 10.5909 5 9.82435V9C5 6.58104 6.71776 4.56329 9 4.10002V3ZM12 16C12 17.1046 11.1046 18 10 18C8.89543 18 8 17.1046 8 16H12Z"
  />
</svg>
